
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Tasks extends Vue {}
